import type { ReactNode } from "react";

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export default function SectionTitle({ title, subtitle, action }: SectionTitleProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1 rounded-full bg-primary-500"></span>
        <div>
          <h2 className="text-lg font-bold tracking-wide text-foreground-950 md:text-xl">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-1 text-xs text-foreground-500 md:text-sm">{subtitle}</p>
          )}
        </div>
      </div>
      {action}
    </div>
  );
}